var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',{attrs:{"col":"12","md":"12"}},[_c('v-alert',{attrs:{"color":"purple","icon":"mdi-teach","outlined":"","text":"","type":"info"}},[_vm._v(" "+_vm._s(_vm.text)+" ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }